<script>
export default {
  name: "customNav",
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<template>
  <div class="customNav">
    <van-nav-bar
        v-if="!isWx"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
    >
    </van-nav-bar>
  </div>
</template>

<style scoped lang="scss">

.customNav{

}


</style>
